import type { InkDocumentV1, InkPoint, InkStroke } from '../../types/ink';

function clamp01(value: number) {
  return Math.max(0, Math.min(1, value));
}

export function normalizeInkPoint(
  x: number,
  y: number,
  t: number,
  width: number,
  height: number,
  pressure?: number,
): InkPoint {
  if (width <= 0 || height <= 0) throw new Error('Ink canvas dimensions must be positive.');
  return {
    x: clamp01(x / width),
    y: clamp01(y / height),
    t: Math.max(0, Math.round(t)),
    ...(pressure === undefined ? {} : { pressure: clamp01(pressure) }),
  };
}

export function createInkDocument(width: number, height: number, strokes: InkStroke[]): InkDocumentV1 {
  if (width <= 0 || height <= 0) throw new Error('Ink canvas dimensions must be positive.');
  return { version: 1, width, height, strokes };
}
